<template>
  <div class="login">
    <img class="logo" src="@/assets/img/login/logo.png" alt="" />
    <div class="form-container">
      <div class="form">
        <a-icon
          class="setting-btn"
          type="setting"
          @click="settingModalShow = true"
        />
        <div class="tab">
          <div
            :class="{
              'tab-item': true,
              active: tabSelectedIndex === ACCOUNT_LOGIN_TYPE,
            }"
            @click="tabSelectedIndex = ACCOUNT_LOGIN_TYPE"
          >
            账号登录
          </div>
          <div
            :class="{
              'tab-item': true,
              active: tabSelectedIndex === ROOM_ID_LOGIN_TYPE,
            }"
            @click="tabSelectedIndex = ROOM_ID_LOGIN_TYPE"
          >
            会议室号登录
          </div>
        </div>
        <a-form-model
          :model="formData"
          @submit="handleSubmit"
          @submit.native.prevent
        >
          <template v-if="tabSelectedIndex === ACCOUNT_LOGIN_TYPE">
            <a-form-model-item>
              <a-input
                v-model="formData.userAccount"
                placeholder="用户名/手机号/邮箱"
                :max-length="32"
              >
                <div slot="prefix" class="input-pre-icon">
                  <user-icon />
                </div>
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-input
                v-model="formData.userPass"
                type="password"
                placeholder="密码"
              >
                <div slot="prefix" class="input-pre-icon">
                  <lock-icon />
                </div>
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-input
                v-model="formData.userRoomId"
                placeholder="会议号/邀请码"
              >
                <div slot="prefix" class="input-pre-icon">
                  <room-icon />
                </div>
              </a-input>
            </a-form-model-item>
          </template>
          <template v-else>
            <a-form-model-item>
              <a-input v-model="formData.roomId" placeholder="会议号/邀请码">
                <div slot="prefix" class="input-pre-icon">
                  <room-icon />
                </div>
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-input
                v-model="formData.password"
                type="password"
                placeholder="会议密码（无密码可不填）"
              >
                <div slot="prefix" class="input-pre-icon">
                  <lock-icon />
                </div>
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-input
                v-model="formData.userName"
                placeholder="昵称"
                :max-length="32"
              >
                <div slot="prefix" class="input-pre-icon">
                  <name-icon />
                </div>
              </a-input>
            </a-form-model-item>
          </template>
          <div class="error-message">{{ errorMessage }}</div>
          <a-button block class="submit-btn" type="primary" html-type="submit">
            立即加入
          </a-button>
        </a-form-model>
      </div>
    </div>
    <a-modal
      class="setting-modal"
      title="设置"
      v-model="settingModalShow"
      :footer="null"
    >
      <a-checkbox v-model="settingAddr" @change="setAddrChange"
        >设置网络登录服务器地址</a-checkbox
      >
      <div class="addr">
        <span>服务器地址</span>
        <a-input
          class="addr-input"
          v-model="cesAddr"
          :disabled="!settingAddr"
        />
        <a-button
          class="apply-btn"
          type="primary"
          :disabled="!settingAddr || !cesAddr"
          @click="applyAddr"
        >
          应用
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { userIcon, lockIcon, roomIcon, nameIcon } from "@/core/icons";

const ACCOUNT_LOGIN_TYPE = 1;
const ROOM_ID_LOGIN_TYPE = 2;
export default {
  name: "Login",
  components: { userIcon, lockIcon, roomIcon, nameIcon },
  data() {
    const wse = window.sessionStorage;
    return {
      ACCOUNT_LOGIN_TYPE,
      ROOM_ID_LOGIN_TYPE,
      tabSelectedIndex: ACCOUNT_LOGIN_TYPE,
      formData: {
        userAccount: "",
        userPass: "",
        userRoomId: "",

        roomId: "",
        password: "",
        userName: "",
      },
      settingAddr: wse.getItem("settingAddr") === "true",
      cesAddr: wse.getItem("cesAddr") || "",
      settingModalShow: false,
      errorMessage: "",
    };
  },
  watch: {
    tabSelectedIndex() {
      this.errorMessage = "";
    },
    settingModalShow(value) {
      !value &&
        (this.cesAddr = window.sessionStorage.getItem("applyedCesAddr"));
    },
  },
  methods: {
    setAddrChange(e) {
      window.sessionStorage.setItem("settingAddr", e.target.checked);
    },
    applyAddr() {
      // TODO 暂时只校验正则，如果能校验服务器是否可连接则更好
      const urlReg =
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      if (urlReg.test(this.cesAddr)) {
        this.settingModalShow = false;
        window.sessionStorage.setItem("cesAddr", this.cesAddr);
        window.sessionStorage.setItem("applyedCesAddr", this.cesAddr);
      } else {
        this.$message.warning("服务器地址错误");
      }
    },
    handleSubmit() {
      const { tabSelectedIndex, formData } = this;
      let requiredField = [];
      if (tabSelectedIndex === ACCOUNT_LOGIN_TYPE) {
        requiredField = [
          {
            key: "userAccount",
            title: "用户名",
          },
          {
            key: "userPass",
            title: "密码",
          },
          {
            key: "userRoomId",
            title: "邀请码",
          },
        ];
      } else {
        requiredField = [
          {
            key: "roomId",
            title: "邀请码",
          },
          {
            key: "userName",
            title: "名称",
          },
        ];
      }
      let invalidField = [];
      requiredField.forEach((e) => {
        !formData[e.key] && invalidField.push(e.title);
      });
      if (invalidField.length > 0) {
        this.errorMessage = "请输入" + invalidField.join("和");
      } else {
        const {
          settingAddr,
          tabSelectedIndex,
          formData: {
            userAccount,
            userPass,
            userRoomId,
            roomId,
            password,
            userName,
          },
        } = this;
        const applyedCesAddr = window.sessionStorage.getItem("applyedCesAddr");
        let query = {
          cesAddr: settingAddr && applyedCesAddr ? applyedCesAddr : undefined,
        };
        if (tabSelectedIndex === ACCOUNT_LOGIN_TYPE) {
          query = {
            ...query,
            roomId: userRoomId,
            userName: userAccount,
            userPass,
            type: 3, // 暂时写死
          };
        } else {
          query = {
            ...query,
            roomId,
            roomPwd: password || undefined,
            userName,
          };
        }
        this.errorMessage = "";
        this.$router.push({ path: "/meeting", query });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@form-container-width: 1332px;
@form-container-height: 534px;
.login {
  @padding: 30px;
  width: 100%;
  height: 100%;
  min-width: @form-container-width + @padding * 2;
  min-height: @form-container-height + @padding * 2;
  padding: @padding;
  background: url(~@/assets/img/login/bg-page.png) no-repeat center/cover;

  .form-container {
    display: flex;
    width: @form-container-width;
    height: @form-container-height;
    justify-content: center;
    align-items: center;
    margin: 115px auto 30px;
    background: url(~@/assets/img/login/bg-container.png) no-repeat center/cover;

    .form {
      width: 400px;
      padding: 50px;
      border-radius: 8px;
      background: #fff;
      position: relative;

      .setting-btn {
        cursor: pointer;
        position: absolute;
        top: 15px;
        right: 15px;
        font-size: 18px;
      }

      .tab {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 50px;

        &-item {
          font-size: 24px;
          color: #42424a;
          cursor: pointer;

          &.active {
            color: #3c98fe;
            position: relative;
            padding-bottom: 10px;

            &::after {
              content: "";
              display: block;
              width: 100%;
              height: 4px;
              background: #3c98fe;
              position: absolute;
              bottom: 0;
              left: 0;
            }
          }
        }
      }

      /deep/ .ant-form-item {
        margin-bottom: 20px;

        .ant-form-item-control {
          line-height: 44px;

          .ant-input-affix-wrapper {
            .ant-input-prefix {
              left: 0;

              .input-pre-icon {
                width: 35px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 1px solid #ebedf0;

                path {
                  fill: #949bae;
                }
              }
            }

            .ant-input {
              height: 44px;
              padding-left: 45px;

              &:hover {
                border-color: #3c98fe;
              }

              &:focus {
                border-color: #3c98fe;
                box-shadow: 0 0 0 2px rgba(60, 152, 254, 0.2);
              }
            }

            &:hover .ant-input {
              border-color: #3c98fe;
            }
          }
        }
      }

      .error-message {
        color: #f5222d;
        min-height: 30px;
        padding: 5px 0;
        line-height: 20px;
      }

      .submit-btn {
        height: 40px;
        background: #3c98fe;
        border-color: #3c98fe;
      }
    }
  }
}

.setting-modal {
  /deep/ .ant-modal-body {
    padding: 30px;

    .addr {
      display: flex;
      justify-content: space-between;
      align-items: center;
      white-space: nowrap;
      margin-top: 10px;

      .addr-input {
        margin-left: 20px;
      }

      .apply-btn {
        width: 100px;
        margin-left: 20px;
      }
    }
  }
}
</style>
